export enum ShortcutType {
	rootOptions = 'rootOptions',
	directResponse = 'directResponse',
}